import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/home')({
  component: lazyRouteComponent(
    () => import('@/features/home/components/home-page'),
    'HomePage'
  ),
})
